export const canShowPropertyAddress = (property: any, site: any) =>
    Boolean(property?.mostrar_endereco && property?.endereco && !site?.ocultar_endereco);

const joinParts = (parts: Array<any>, separator = ', ') =>
    parts
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .join(separator);

export const formatPropertyAddress = (
    property: any,
    site: any,
    options: { includeLabel?: boolean; includeLocation?: boolean } = {}
) => {
    const isSite2551 = Number(site?.id) === 2551;
    const street = isSite2551
        ? joinParts([property?.endereco, property?.numero])
        : String(property?.endereco || '').trim();
    const location = joinParts([property?.bairro?.nome, property?.cidade?.nome], ' - ');
    const buildingName = String(property?.empreendimento?.nome || '').trim();

    const address = isSite2551
        ? joinParts([street, buildingName, location])
        : options.includeLocation
            ? joinParts([street, location])
            : street;

    return options.includeLabel ? `Endereço: ${address}` : address;
};
